import REVIEW_ONBOARDING_STEP from 'components/shared/OnboardingWizard/components/Header/REVIEW_ONBOARDING_STEP';

import STEP_DEFINITIONS from './stepDefinitions';
import SUBSTEP_DEFINITIONS from './substepDefinitions';

// Single source of truth consumed by:
//   - Stepper Footer (components/shared/Stepper/components/Footer/Footer.jsx)
//     hides the "Delegate this task" affordance while on one of these steps/substeps.
//   - DelegationTasks (useDelegationState) excludes these steps/substeps from the
//     delegation table so they can't be selected and delegated.

const ACKNOWLEDGEMENT_SUBSTEPS = SUBSTEP_DEFINITIONS[STEP_DEFINITIONS.ACKNOWLEDGEMENTS.code];

export const NON_DELEGATABLE_STEP_CODES = [
  STEP_DEFINITIONS.DELEGATION.code,
  REVIEW_ONBOARDING_STEP.code
];

export const NON_DELEGATABLE_SUBSTEP_CODES = [
  ACKNOWLEDGEMENT_SUBSTEPS.TERMS_AND_CONDITIONS.code,
  ACKNOWLEDGEMENT_SUBSTEPS.RESPONSIBILITIES.code
];

export const isDelegatableTarget = ({ stepCode, substepCode } = {}) =>
  !NON_DELEGATABLE_STEP_CODES.includes(stepCode) &&
  !NON_DELEGATABLE_SUBSTEP_CODES.includes(substepCode);
